<template>
  <g>
    <path
      d="M18 13.0002H19V15.0002H14V9.00018H20C20.55 9.00018 21 8.55018 21 8.00018C21 7.45018 20.55 7.00018 20 7.00018H14C12.9 7.00018 12 7.90018 12 9.00018V15.0002C12 16.1002 12.9 17.0002 14 17.0002H19C20.1 17.0002 21 16.1002 21 15.0002V12.0002C21 11.4502 20.55 11.0002 20 11.0002H18C17.45 11.0002 17 11.4502 17 12.0002C17 12.5502 17.45 13.0002 18 13.0002Z"
    />
    <path
      d="M4 13.0002H8V15.0002H4C3.45 15.0002 3 15.4502 3 16.0002C3 16.5502 3.45 17.0002 4 17.0002H8C9.1 17.0002 10 16.1002 10 15.0002V13.0002C10 11.9002 9.1 11.0002 8 11.0002H5V9.00018H9C9.55 9.00018 10 8.55018 10 8.00018C10 7.45018 9.55 7.00018 9 7.00018H4C3.45 7.00018 3 7.45018 3 8.00018V12.0002C3 12.5502 3.45 13.0002 4 13.0002Z"
    />
  </g>
</template>
